/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import {t} from "../../../trans";
import * as pageComponents from "../PageComponent";
import PageTitle from "../PageTitle";
import {Modal} from "../../../components/Bootstrap";
import ActionButtons from "../ActionButtons";
import {GotoBackAction} from "../../../services/PageAction/PageAction";

class BasePageFrame extends React.Component {
    static propTypes = {
        navResource: PropTypes.string,
        navField: PropTypes.string,
        basePath: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            fieldPath: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentFieldPath: PropTypes.string.isRequired,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        breadcrumb: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            to: PropTypes.string
        })).isRequired,
        /**
         * Actions
         */
        actions: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.node,
            action: PropTypes.string.isRequired
        })),
        /**
         * @type {OnActionCallback}
         */
        onAction: PropTypes.func,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
        options: PropTypes.shape({
            component: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
            schema: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired
        }).isRequired,

    };

    static defaultProps = {
    };

    constructor(props) {
        super(props);
        this.state = {
        };
        this.onAction = this.onAction.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    /**
     * @returns {XML}
     */
    render() {
        if (this.props.params.isModal) return this.renderModalFrame();
        else return this.renderFrame();
    }

    /**
     * @privete
     * @returns {XML}
     */
    renderModalFrame() {
        return (
            <Modal modalClass="inmodal fade" modalAttrib={{"data-backdrop": "static", "data-keyboard": "false"}} id="showResourceModal" tabIndex="-1" role="dialog" aria-hidden="true" onClose={this.onClose}>
                <Modal.Content>
                    <Modal.Header>
                        <button type="button" className="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span className="sr-only">{t("Close")}</span></button>
                        <h4 className="modal-title">{this.getTitle()}</h4>
                    </Modal.Header>
                    <Modal.Body>
                        {this.renderBody()}
                    </Modal.Body>
                    <Modal.Footer>
                        <ActionButtons type="single" actions={this.props.actions} onAction={this.props.onAction} location={this.props.location}/>
                    </Modal.Footer>
                </Modal.Content>
            </Modal>
        );
    }

    /**
     * @private
     * @returns {XML}
     */
    renderFrame() {
        return (
            <div>
                <PageTitle title={this.getTitle()} breadcrumb={this.props.breadcrumb} actions={this.props.actions} onAction={this.props.onAction} location={this.props.location}/>
                <div className="wrapper wrapper-content animated fadeInRight">
                    {this.renderBody()}
                </div>
            </div>
        );
    }

    /**
     * Child classes should overload this method!
     * @abstract
     * @returns {null}
     */
    renderBody() {
        return null;
    }

    /**
     * Returns n-th page component object from UI Schema.
     * This method is utility method for use in child classes.
     * @protected
     * @param i
     * @returns {*}
     */
    getPageComponent(i=0) {
        let components = this.getPageComponents();
        if (components == null || components.length <= i) return null;
        return components[i];
    }

    /**
     *
     * @param {PageAction} action
     */
    onAction(action, data) {
        if (this.props.onAction) {
            /**
             * @type {PageAction}
             */
            action = _.extend({}, action, {props: this.props.params});
            if (data) action.data = data;
            this.props.onAction(action);
        }
    }

    onClose() {
        if (this.props.onAction) {
            this.props.onAction(new GotoBackAction({props: this.props.params}));
        }
    }

    /**
     * Creates page components based by "component" element from Nav Schema.
     * @protected
     * @returns {*}
     */
    getPageComponents() {
        if (!this.props.options || !this.props.options.component) return null;
        let items = this.props.options.component;
        if (!_.isArray(items)) items = [items];
        let schema = this.props.options.schema;
        if (!_.isArray(schema)) schema = [schema];
        let frame = this.getFrame();

        let components = [];
        for (let i = 0; i < items.length; i++) {
            let Component = this.getComponentObject(items[i]);
            if (!Component) return null;
            let componentItem = (
                <Component
                    key={i}
                    basePath={this.props.basePath}
                    params={this.props.params}
                    navResource={this.props.navResource}
                    navField={this.props.navField}
                    location={this.props.location}
                    router={this.props.router}
                    route={this.props.route}
                    schema={schema[i]} />
            );
            if (frame.length <= i || frame[i]) {
                components.push(this.renderPageComponentWithFrame(componentItem));
            } else {
                components.push(componentItem);
            }
        }
        if (components.length === 0) return null;
        return components;
    }

    /**
     * @private
     * @param name
     * @returns {null}
     */
    getComponentObject(name) {
        if (_.has(pageComponents, name)) return pageComponents[name];
        return null;
    }

    /**
     * @private
     * @returns {string|Array}
     */
    getFrame() {
        let frame = this.props.options.frame;
        if (!_.isArray(frame)) {
            if (frame == null) frame = true;
            frame = [frame];
        }
        return frame;
    }

    /**
     * @private
     * @param component
     * @returns {XML}
     */
    renderPageComponentWithFrame(component) {
        return (
            <div className="ibox-content">
                {component}
            </div>
        );
    }

    /**
     * Returns component title
     * @returns {string}
     */
    getTitle() {
        let breadcrumb = this.props.breadcrumb;
        if (breadcrumb == null || breadcrumb.length == 0) return null;
        return breadcrumb[breadcrumb.length-1].title;
    }


}

export default BasePageFrame;
